import React from 'react';
import PropTypes from 'prop-types';
import { createPortal, unmountComponentAtNode } from 'react-dom';

class RenderInNode extends React.PureComponent {
  componentWillUnmount() {
    const { node } = this.props;

    unmountComponentAtNode(node);
  }

  render() {
    const { children, node } = this.props;

    return createPortal(
      children,
      node,
    );
  }
}

RenderInNode.propTypes = {
  children: PropTypes.instanceOf(Array).isRequired,
  node: PropTypes.instanceOf(Element).isRequired,
};

export default RenderInNode;
